import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconOtrosOn(props) {
    return (
        <svg
            width={246}
            height={246}
            viewBox="0 0 246 246"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={123} cy={123} r={117} fill="#000" />
            <path
            d="M122.995 245.485C55.175 245.485 0 190.417 0 122.742 0 55.058 55.176 0 122.995 0 190.824 0 246 55.058 246 122.742c0 67.675-55.176 122.743-123.005 122.743zm0-238.628C58.977 6.857 6.872 58.841 6.872 122.732c0 63.902 52.105 115.876 116.123 115.876 64.038 0 116.143-51.984 116.143-115.876 0-63.891-52.105-115.875-116.143-115.875z"
            fill="#000"
            />
            <path
            d="M185.523 38.668c-1.161-10.64 6.572-20.192 17.215-21.35 10.663-1.158 20.225 6.528 21.386 17.168 1.16 10.62-6.532 20.193-17.195 21.34-10.643 1.158-20.246-6.538-21.406-17.158z"
            fill="#000"
            />
            <path
            d="M194.435 37.7c-.63-5.74 3.511-10.86 9.273-11.489 5.762-.628 10.893 3.494 11.513 9.233.621 5.72-3.501 10.86-9.262 11.489-5.752.629-10.903-3.514-11.524-9.233z"
            fill="#FFDD00"
            />
            <path
            d="M122.785 141.727c8.482.08 15.214-6.448 15.284-14.832.08-8.465-6.462-15.172-14.864-15.252-8.483-.08-15.204 6.448-15.284 14.832-.07 8.465 6.471 15.172 14.864 15.252zm-52.985 0c8.452.01 15.164-6.708 15.124-15.122-.05-8.275-6.622-14.892-14.874-14.962-8.432-.07-15.315 6.588-15.405 14.912-.09 8.285 6.782 15.162 15.155 15.172zm106.39 0c8.372-.01 15.244-6.887 15.164-15.162-.09-8.334-6.962-14.992-15.394-14.922-8.252.07-14.824 6.677-14.874 14.952-.06 8.424 6.652 15.142 15.104 15.132z"
            stroke="#000"
            strokeWidth={7}
            strokeMiterlimit={10}
            />
            <path
            d="M122.785 141.727c-8.402-.08-14.934-6.787-14.864-15.252.07-8.384 6.802-14.902 15.284-14.832 8.402.07 14.944 6.787 14.864 15.252-.07 8.384-6.792 14.912-15.284 14.832zM69.8 141.727c-8.373-.01-15.245-6.897-15.155-15.172.09-8.324 6.972-14.992 15.405-14.912 8.242.07 14.824 6.687 14.874 14.962.05 8.414-6.672 15.142-15.124 15.122zM176.19 141.727c-8.452.01-15.164-6.707-15.114-15.132.05-8.275 6.622-14.892 14.874-14.952 8.432-.07 15.305 6.598 15.395 14.922.09 8.285-6.782 15.152-15.155 15.162z"
            stroke="#FFDD00"
            strokeWidth={7}
            strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgIconOtrosOn;